import { InputChangeState, InputErrorState } from '~/definitions/standAdmin';

export const initialState: InputChangeState = {
    coopId: '',
    birthdate: '',
};

export const initialErrors: InputErrorState = {
    coopId: false,
    birthdate: false,
};
